import { Box } from '@mui/material'
import React from 'react'

export default function Footer() {
    return (
        <Box display="flex" flexDirection="row" py={1} justifyContent="center" alignItems="center">
            <h6 className="ui-typo--h6 ui-margin--0 ui-font-weight--light app-font--secondary app-font-size--normal">
                Made with <span>💗</span> by
                Bharath Kishore <span className="ui-typo--h6 ui-theme--secondary app-font--secondary app-font-size--normal">&copy; 2021</span></h6>
        </Box>
    )
}

